import React from 'react'
import { motion } from 'framer-motion'
import "../components/Toast/G.css"
import logo from '../Loading/loadinglogo.png'

export default function Loading() {
  return (
    <div className="fixed inset-0 z-[9999] flex justify-center items-center bg-[#0a0a0a]">
      {/* Background effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-cyan-500/20 rounded-full blur-[100px] mix-blend-screen" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-blue-500/20 rounded-full blur-[80px] mix-blend-screen" />
      </div>

      <div className="relative flex flex-col items-center justify-center">
        {/* Logo Animation */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
          }}
          className="relative mb-10"
        >
          {/* Glowing rings around the logo */}
          <motion.div
            className="absolute inset-0 rounded-full border border-cyan-500/30"
            animate={{ scale: [1, 1.5, 2], opacity: [0.8, 0.4, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          />
          <motion.div
            className="absolute inset-0 rounded-full border border-blue-500/30"
            animate={{ scale: [1, 1.5, 2], opacity: [0.8, 0.4, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: "linear", delay: 1 }}
          />

          <motion.div
             className="relative z-10 w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden border border-white/10 shadow-[0_0_40px_rgba(6,182,212,0.3)] bg-white flex items-center justify-center p-2"
             animate={{
                boxShadow: [
                  "0 0 40px rgba(6,182,212,0.3)",
                  "0 0 80px rgba(59,130,246,0.5)",
                  "0 0 40px rgba(6,182,212,0.3)"
                ]
             }}
             transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
          >
            <motion.img
              src={logo}
              alt="Logo"
              className="w-full h-full object-cover rounded-full"
              animate={{ scale: [1, 1.05, 1] }}
              transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            />
          </motion.div>
        </motion.div>

        {/* Loading Text & Bar */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="flex flex-col items-center gap-4"
        >
          <motion.p
            className="text-sm md:text-base font-medium tracking-[0.25em] text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 uppercase"
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          >
            Loading...
          </motion.p>
          
          {/* Progress Bar */}
          <div className="w-48 md:w-64 h-[2px] bg-white/10 rounded-full overflow-hidden relative">
            <motion.div
              className="absolute top-0 left-0 h-full bg-gradient-to-r from-cyan-400 to-blue-500"
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: 2, ease: "easeInOut", repeat: Infinity }}
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
}
